var map = {
	"./sd1.jpg": 950,
	"./sd2.jpg": 4650,
	"./sd3.jpg": 4081,
	"./sd4.jpg": 5811,
	"assets/collections/editorials/sandra dorsz/sd1.jpg": 950,
	"assets/collections/editorials/sandra dorsz/sd2.jpg": 4650,
	"assets/collections/editorials/sandra dorsz/sd3.jpg": 4081,
	"assets/collections/editorials/sandra dorsz/sd4.jpg": 5811
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9883;